'use strict';

var assign = require('xtend/mutable');

module.exports = CardType;

function CardType(data) {
  if (!(this instanceof CardType)) return new CardType(data);
  assign(this, data);
}

CardType.prototype.digits = 16;
CardType.prototype.cvcLength = 3;
CardType.prototype.luhn = true;
CardType.prototype.groupPattern = /(\d{1,4})(\d{1,4})?(\d{1,4})?(\d{1,4})?/;

CardType.prototype.group = function (number) {
  return (number.match(this.groupPattern) || []).slice(1).filter(Boolean);
};

CardType.prototype.test = function (number, eager) {
  return this[eager ? 'eagerPattern' : 'pattern'].test(number);
};